module.exports = __webpack_public_path__ + "img/art_still_with_you.177942e4.jpg";